// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  remoteEnvUrl:"https://cams.wakandi.com/device/country-network.json",
  //env value is being used for fetching and undating environment configuration
  //from file placed at "remoteEnvUrl" if not found defaultUrl would be used as base api url
  // env:'local_configuration',
  env:'dev_configuration',
  apiUrl:
    {
      // "defaultUrl": "http://localhost:21021/api",
      "defaultUrl": "cams-service",
      "coreUrl": "core-service",
      "invoiceUrl": "invoice-service"
    },
  localeMappings : [
    {
      "from": "pt-BR",
      "to": "pt"
    },
    {
      "from": "zh-CN",
      "to": "zh"
    },
    {
      "from": "he-IL",
      "to": "he"
    }
  ],
  culture:'sw',
  apppath:'/'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in productn mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
